<template>
    <div class="reservations" v-if="date !== null">
        <div class="page-header">
            <h1>
                Breakfasts

                <small class="controls">
                    {{date | moment('DD MMMM \'YY')}}&nbsp;

                    <span class="pe-7s-angle-left-circle navigatable" @click="previous()"></span>&nbsp;
                    <span class="pe-7s-angle-right-circle navigatable" @click="next()"></span>
                </small>

                <div class="pull-right hidden-print">
                    <date-picker v-model="date" :config="{format: 'DD MMMM YYYY'}"></date-picker>
                </div>

                <div class="pull-right hidden-print">
                    <print></print>&nbsp;
                </div>
            </h1>
        </div>

        <loader v-if="!hasLoaded"></loader>

        <template v-else>
            <div class="text-center">
                <span class="lead">{{reservations.length}} room(s) / {{eatingGuests}} guests</span>
            </div>

            <br />

            <div class="list-group">
                <router-link :to="{name: 'reservations.view', params: {id: reservation.id}}" class="list-group-item" v-for="reservation in reservations" :key="reservation.id">
                    {{reservation.room.title}}<br />
                    <span class="muted">{{reservation.name}}</span> / {{reservation.numberOfBreakfasts}} guest(s)

                    <span class="pe-7s-angle-right-circle pull-right action hidden-print"></span>
                </router-link>
            </div>
        </template>
    </div>
</template>

<style lang="scss" scoped>
    .reservations {
        .controls {
            > * {
                cursor: pointer;
            }
        }

        .list-group {
            .list-group-item {
                .action {
                    color: #828282;
                    font-size: 25px;
                    margin-top: -12px;
                }

                &:hover,
                &.navigation-selected-active {
                    color: #555;
                    text-decoration: none;
                    background-color: #f5f5f5;

                    .action {
                        color: #ff3d70;
                    }
                }
            }
        }
    }
</style>

<script>
    import Room from '@/components/calendar/Room'
    import Loader from '@/components/layout/Loader'
    import Print from '@/components/layout/Print'

    const ReservationService = require('@/services/reservations/ReservationService')
    const moment = require('moment')

    import DatePicker from 'vue-bootstrap-datetimepicker'

    export default {
        data() {
            return {
                date: null,
                reservations: [],
                hasLoaded: false,
                loaded: 0
            }
        },

        computed: {
            eatingGuests() {
                let eatingGuests = 0

                this.reservations.forEach((reservation) => {
                    eatingGuests += reservation.numberOfBreakfasts
                })

                return eatingGuests
            }
        },

        watch: {
            loaded() {
                if (this.loaded !== this.rooms.length) {
                    return
                }

                this.hasLoaded = true
            },

            date() {
                this.load()
            }
        },

        mounted() {
            this.setDefaultDate()
            this.load()
        },

        methods: {
            setDefaultDate() {
                this.date = moment()
            },

            previous() {
                this.reset()

                this.date = moment(this.date.subtract(1, 'day'))
            },

            /**
             * Next
             **/
            next() {
                this.reset()

                this.date = moment(this.date.add(1, 'day'))
            },

            reset() {
                this.loaded = 0
                this.hasLoaded = false
            },

            load() {
                this.hasLoaded = false

                let date = moment(this.date)
                date = date.subtract(1, 'day')

                const options = {
                    sort: [
                        {
                            key: 'room.order',
                            direction: 'ASC'
                        }
                    ],

                    includes: ['room'],

                    filter_groups: [
                        {
                            filters: [
                                {
                                    key: 'belongsToDate',
                                    value: date.format('YYYY-MM-DD'),
                                    operator: 'eq'
                                },
                                {
                                    key: 'numberOfBreakfasts',
                                    value: '0',
                                    operator: 'gt'
                                },
                            ]
                        }
                    ]
                }

                ReservationService.findAll(options, (response) => {
                    const data = response.data

                    this.reservations = data.rows
                    this.hasLoaded = true
                })
            }
        },

        components: {
            Loader,
            Room,
            DatePicker,
            Print
        }
    }
</script>


// WEBPACK FOOTER //
// Breakfasts.vue?33b8dfde